import api from './api';
import types from './mutation-types';
import moment from 'moment';

function getRowKey() {
	return moment.now().toString();
}

export default {
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchInit_({ commit }) {
		commit(types.SEARCH_INIT);
	},
	setStateClear_({ commit }) {
		commit(types.STATE_CLEAR);
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.GROUPS, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	
	addExcelUpload_({ commit }, { formData }) {
		return api
			.addExcelUpload({ formData })
			.then(data => {
				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},

	async getMdjRsltList_({ commit, state }) {
		try {
			const { searchParams, groups } = state;
			const data = await api.getMdjRsltList({ searchParams, groups });
			if (data.header.code === 0) {
				const { resultList, pagingInfo } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'groups', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'gridList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	},

	postSearchSelectList_({ commit }) {
		return api
			.postSearchSelectList()
			.then(data => {
				if (data.header.code === 0) {
					const prvsCdList = data.body.prvsClCdList;
					prvsCdList.length && prvsCdList.forEach(row => {
						row.label = row.commCdName;
						row.value = row.commCd
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'prvsClCdList',
						value: prvsCdList
					});

					const ckuPrvsCdList = data.body.ckuPrvsCdList;
					ckuPrvsCdList.length && ckuPrvsCdList.forEach(row => {
						row.label = row.commCdName;
						row.value = row.commCd
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'ckuPrvsCdList',
						value: ckuPrvsCdList
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'ckuPrvsCdAllList',
						value: ckuPrvsCdList
					});

					const ynCdList = data.body.ynCdList;
					ynCdList.length && ynCdList.forEach(row => {
						row.label = row.commCdName;
						row.value = row.commCd
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'ynCdList',
						value: ynCdList
					});
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},

};
